// /components/reports/components/ClassSelector.js
import React from 'react';
import { Form } from 'react-bootstrap';

function ClassSelector({ classes, selectedClass, onChange, isLoading }) {
  return (
    <Form.Group controlId="classSelect">
      <Form.Label>1. Select Class</Form.Label>
      <Form.Select
        name="selectedClass"
        value={selectedClass}
        onChange={onChange}
      >
        <option value="">{isLoading ? 'Loading...' : 'Choose...'}</option>
        {classes?.map((cls) => (
          <option key={cls._id} value={cls._id}>
            {cls.name}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );
}

export default ClassSelector;